import { GETMEMBER_SUCCESS, GETMEMBER_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETMEMBER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getMemberReducer;



